import { render, staticRenderFns } from "./DataExportMenu.vue?vue&type=template&id=520f6d47&scoped=true"
import script from "./DataExportMenu.vue?vue&type=script&lang=js"
export * from "./DataExportMenu.vue?vue&type=script&lang=js"
import style0 from "./DataExportMenu.vue?vue&type=style&index=0&id=520f6d47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f6d47",
  null
  
)

export default component.exports